import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../components/ProductSalesReport.css";

const API = "https://newerp.awasthivitality.com/public/api/incentive/product-sales";

const ProductSalesReport = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ totals state
  const [totals, setTotals] = useState({
    total_quantity: 0,
    total_amount: 0,
    total_discount: 0
  });

  const params = new URLSearchParams(location.search);
  const userId = params.get("user_id");
  const fromDate = params.get("from_date");
  const toDate = params.get("to_date");

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    try {
      const query = new URLSearchParams();

      if (userId) query.append("user_id", userId);
      if (fromDate) query.append("from_date", fromDate);
      if (toDate) query.append("to_date", toDate);

      const res = await fetch(`${API}?${query.toString()}`);
      const result = await res.json();

      console.log("API RESULT:", result); // 🔥 check this

      if (result.success) {
        const rows = result.data || [];
        setData(rows);

        // ✅ UNIVERSAL TOTAL FIX
        if (result.summary) {
          // Case 1
          setTotals(result.summary);
        } else if (result.total_quantity !== undefined) {
          // Case 2
          setTotals({
            total_quantity: result.total_quantity,
            total_amount: result.total_amount,
            total_discount: result.total_discount
          });
        } else {
          // Case 3 (calculate manually)
          const totalQty = rows.reduce(
            (sum, item) => sum + Number(item.total_quantity || 0),
            0
          );

          const totalAmt = rows.reduce(
            (sum, item) => sum + Number(item.total_amount || 0),
            0
          );

          const totalDisc = rows.reduce(
            (sum, item) => sum + Number(item.total_discount || 0),
            0
          );

          setTotals({
            total_quantity: totalQty,
            total_amount: totalAmt,
            total_discount: totalDisc
          });
        }
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const userName = data.length > 0 ? data[0].user_name : "";

  return (
    <div className="psr-container">

      {/* Header */}
      <div className="psr-header">
        <div>
          <h2 className="psr-title">Product Sales Report</h2>

          {userName && (
            <h4 className="psr-username">
              User: {userName}
            </h4>
          )}
        </div>

        <button className="psr-back-btn" onClick={() => navigate("/staff")}>
          Back
        </button>
      </div>

      {/* Filters */}
      <div className="psr-filters">
        <strong>Filters:</strong>
        {userId ? ` User ID: ${userId}` : " All Users"} |
        {fromDate ? ` From: ${fromDate}` : " No From Date"} |
        {toDate ? ` To: ${toDate}` : " No To Date"}
      </div>

      {/* Loader */}
      {loading ? (
        <p className="psr-loading">Loading...</p>
      ) : (
        <>
          {/* ✅ Summary Cards */}
          <div className="psr-summary">
            <div className="psr-card">
              <span>Total Qty</span>
              <strong>{totals.total_quantity}</strong>
            </div>

            <div className="psr-card">
              <span>Total Amount</span>
              <strong>₹{totals.total_amount.toLocaleString()}</strong>
            </div>

            <div className="psr-card">
              <span>Total Discount</span>
              <strong>₹{totals.total_discount.toLocaleString()}</strong>
            </div>
          </div>

          {/* Table */}
          <div className="psr-table-wrapper">
            <table className="psr-table">
              <thead className="psr-thead">
                <tr>
                  <th>S.No</th>
                  <th>User</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Amount</th>
                  <th>Discount</th>
                </tr>
              </thead>

              <tbody className="psr-tbody">
                {data.length > 0 ? (
                  data.map((item, i) => (
                    <tr key={i} className="psr-row">
                      <td>{i + 1}</td>
                      <td>{item.user_name}</td>
                      <td>{item.product_name}</td>
                      <td>{item.total_quantity}</td>
                      <td className="psr-amount">
                        ₹{Number(item.total_amount).toLocaleString()}
                      </td>
                      <td>{item.total_discount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" align="center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ProductSalesReport;